import NutrientViewer from '@nutrient-sdk/viewer';

/**
 * WARNING! THIS CONFIG SHOULD BE OUR ENTRYPOINT FOR PSPDFKit
 * - DON'T import PSPDFKit diretly from 'pspdfkit'
 *   `import PSPDFKit from 'pspdfkit';`
 */

/**
 * This makes sure to set up the configuration options ONCE, as those will
 * become readonly after the first `PSPDFKit.load` method is invoked,
 * which would throw errors if multiple PDFs are being loaded at once,
 * such as in a room
 */
NutrientViewer.Options.DISABLE_KEYBOARD_SHORTCUTS = true;

export default NutrientViewer;
